import ReduxRestEntity from '../../../../utils/reduxRestEntity';
import JobManageAPI from '../../../../utils/api/jobManageAPI';

const entity = new ReduxRestEntity({
  name: 'jobManage',
  api: JobManageAPI(),
});

export default entity;
